/**
 * _Slideshow.js
 */

import $ from 'jquery';
import Utilities from './Utilities';
require('../vendor/Slick');

class Slideshow {

    constructor() {

        const $el = $('.slideshow').not('.slick-initialized');
        const $explore = $('.explore-row');

        var leftArrow = `
            <button class="left-arrow d-flex" aria-label="Previous">
                <?xml version="1.0" encoding="UTF-8" standalone="no"?>
                <svg width="103px" height="23px" viewBox="0 0 103 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="1-2-copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Room-Detail-2-Copy-4" transform="translate(-76.000000, -1254.000000)" fill="#ED6A57">
                            <g id="Group-7" transform="translate(75.000000, 310.000000)">
                                <g id="Group-6-Copy-2" transform="translate(52.500000, 955.500000) rotate(-360.000000) translate(-52.500000, -955.500000) translate(1.000000, 944.000000)">
                                    <g id="Icon-/-Arrow">
                                        <polygon id="Mask" points="4.26874269 10.396679 12.9317793 1.61254613 11.3833138 0 0 11.5 11.3833138 23 12.9317793 21.3874539 4.26874269 12.603321 102.165039 12.603321 102.165039 10.396679"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                &nbsp;
            </button>
            `,
            rightArrow = `
            <div class="slide-count red-text"></div>
            <button class="right-arrow d-flex" aria-label="Next">
                <?xml version="1.0" encoding="UTF-8" standalone="no"?>
                <svg width="103px" height="23px" viewBox="0 0 103 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="1-2-copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Room-Detail-2-Copy-4" transform="translate(-1623.000000, -1254.000000)" fill="#ED6A57">
                            <g id="Group-7" transform="translate(75.000000, 310.000000)">
                                <g id="Group-6-Copy-3" transform="translate(1599.500000, 955.500000) rotate(-180.000000) translate(-1599.500000, -955.500000) translate(1548.000000, 944.000000)">
                                    <g id="Icon-/-Arrow">
                                        <polygon id="Mask" points="4.26874269 10.396679 12.9317793 1.61254613 11.3833138 0 0 11.5 11.3833138 23 12.9317793 21.3874539 4.26874269 12.603321 102.165039 12.603321 102.165039 10.396679"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </button>`;

        $el.each(function () {
            var slickIndividual = $(this),
                arrowsContainer = slickIndividual.siblings('.slideshow-nav');

            slickIndividual.slick({
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                appendArrows: arrowsContainer,
                lazyLoad: 'ondemand',
                nextArrow: rightArrow,
                prevArrow: leftArrow,
            });

            var slideCount = arrowsContainer.find('.slide-count'),
                totalSlides = slickIndividual.slick('getSlick').slideCount,
                initCurrentSlide = slickIndividual.slick('slickCurrentSlide') + 1;
                

            slideCount.text(parseInt(initCurrentSlide, 10) + ' OF ' + totalSlides);

            slickIndividual.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                slideCount.text(parseInt(nextSlide + 1, 10) + ' OF ' + totalSlides);
            });
        })

        $explore.each(function () {
            var slickIndividual = $(this),
                arrowsContainer = $('.explore-slideshow-nav');

            slickIndividual.slick({
                infinite: false,
                speed: 500,
                fade: false,
                slidesToShow: 1,
                cssEase: 'linear',
                appendArrows: arrowsContainer,
                arrows: false,
                lazyLoad: 'ondemand',
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: "unslick"
                    }
                ]
            });

            var slideCount = arrowsContainer.find('.explore-slide-count'),
                totalSlides = slickIndividual.slick('getSlick').slideCount,
                initCurrentSlide = slickIndividual.slick('slickCurrentSlide') + 1;


            slideCount.text(parseInt(initCurrentSlide, 10) + ' OF ' + totalSlides);

            slickIndividual.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                slideCount.text(parseInt(nextSlide + 1, 10) + ' OF ' + totalSlides);

                if (nextSlide === totalSlides - 1) {
                    $('.explore-row .slick-list').addClass('last-slide');
                } else if (nextSlide === 0) {
                    $('.explore-row .slick-list').removeClass('last-slide');
                }
            });

            $(window).on('orientationchange', function () {
                slickIndividual.slick('resize');
            });
        })

    }

}
new Slideshow();
